<template>
    <v-row>
        <v-col cols="12" class="label pb-0 pt-1 mb-n1" v-if="label">
            {{ label }}
        </v-col>
        <v-col v-for="(item,i) in itemsComputed" :key="i" cols="12" :md="forceCols ? 12 : 6" :lg="forceCols ? 6 : 4">
            <v-btn
                :class="['normal-btn', {'readonly': readonly}]"
                block depressed
                :outlined="!isSelected(item)"
                color="primary"
                @click="onSelect(item)"
            >
                <v-icon left v-if="isSelected(item)">mdi-check</v-icon>
                {{ item.name }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: "KimsaButtonSelector",
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Array,
            default: () => [],
        },
        itemValue: {
            type: String,
            default: 'value'
        },
        title: {
            type: String,
            default: null
        },
        rules: {
            type: Array,
            default: () => [],
        },
        details: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        noObject: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: null,
        },
        forceCols: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            model: [],
        }
    },
    computed: {
        itemsComputed(vm = this) {
            if (!vm.noObject) return vm.items
            return vm.items.map(item => {
                return {name: item.name, value: item.id}
            })
        },
    },
    mounted() {
        const vm = this
        vm.setDefaults()
    },
    methods: {
        setDefaults() {
            const vm = this
            if (vm.value) vm.model = vm.value
        },
        onSelect(item) {
            const vm = this
            if (vm.readonly) return;
            if (vm.isSelected(item)) return vm.model = vm.model.filter(profile => profile !== item[vm.itemValue])
            vm.model.push(item[vm.itemValue])
        },
        isSelected(item) {
            const vm = this
            return vm.model.find(it => it === item[vm.itemValue])
        }
    },
    watch: {
        value() {
            this.setDefaults()
        },
        model(val) {
            this.$emit('change', val)
        }
    }
}
</script>

<style scoped>

.readonly {
    cursor: default;
    pointer-events: none;
}

</style>